import React from 'react';
import Pic1 from '../../InstallImages/Modules/CS325W';


const cs325Link = <a href="https://www.dropbox.com/s/v5w3wvrqeo3qium/Canadian%20Solar%20HIDM%2C%20325W%2C%20PERC%2C%20BBB%2C%2060C%2C%2035mm_CS1H-325MS.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">

            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                With Canadian Solar’s innovative module technology and Mono-PERC cell technology, we will offer our customers high power modules up to 325W with enhanced aesthetics appearance. Through maximizing the light absorption area and removing the loss of ribbon resistance, the module efficiency can reach up to 19.57 %.
            </p>
            <p className="specsText">
                CANADIAN SOLAR (USA), INC. is committed to providing high quality solar products, solar system solutions and services to customers around the world. As a leading PV project developer and manufacturer of solar modules with over 26 GW deployed around the world since 2001, Canadian Solar Inc. (NASDAQ: CSIQ) is one of the most bankable solar companies worldwide.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">All Black</li>
                <li className="specsText">Solvana tried and Tested</li>
                <li className="specsText">Great Value</li>
                <li className="specsText">Versitile</li>
                <li className="specsText">{cs325Link}</li>
            </ul>
        </div>
    </div>
);


export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/cs325bbb.js